import type { UserResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';
import { toLinkedInUrlBody } from '@/shared/linkedin/linkedin-url';

import type { AdminDraft } from '../../_shared/domain/administrator-draft.model';
import type { EditAdministratorGateway } from './edit-administrator.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the Edit-administrator endpoints and body mappings (kept 1:1 with the original
 * `EditAdmin` page). Loading reuses the admin index list then finds by id, as
 * the original page did (no dedicated GET /users/:id).
 */
export const httpEditAdministratorGateway: EditAdministratorGateway = {
  loadAdministrator: async (id: string) => {
    const users = await api.get<UserResponse[]>('/users?role=admin');
    return users.find((u) => u.id === id) ?? null;
  },
  updateAdministrator: async (id: string, draft: AdminDraft) => {
    await api.patch(`/users/${id}`, {
      first_name: draft.firstName.trim(),
      last_name: draft.lastName.trim(),
      email: draft.email.trim(),
      admin_role: draft.role,
      // Always sent: an emptied field is how the URL is cleared (`null`, #617).
      linkedin_url: toLinkedInUrlBody(draft.linkedinUrl),
    });
  },
  setArchived: async (id: string, archived: boolean) => {
    await api.patch(`/users/${id}/archive`, { archived });
  },
};
